<template>
    <div id="pageTable">
        <v-overlay :value="loadingLottie"  :z-index="999" >
            <div class="align-center justify-center text-center">
                <v-progress-circular
                    indeterminate
                    :size="100"
                    :width="7"
                    color="#2DB9D1"
                >
                    <v-img
                        src="/static/icon/favicon.ico"
                        :width="60"
                    ></v-img>
                </v-progress-circular>
                <p class="mt-5">{{fraseLoading}}</p>
            </div>
        </v-overlay>
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa' && rol != 'admin-sucursal' && rol != 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableUsuarios"
                        :tableName="'Usuarios'"
                        :url="url"
                        :columns="columns"
                        @loadModalData="loadModalData"
                        :filters="filters"
                        @setFilters="setFilters"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abreModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>

                            <v-menu offset-y content-class="menuClassAcciones" v-if="rol=='root'|| rol=='admin' || rol=='admin-empresa' || rol=='admin-sucursal'">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        dark
                                        class="btnAcciones pr-1 mr-3"
                                        v-bind="attrs"
                                        v-on="on"
                                        elevation="0"
                                    >
                                        Acciones 
                                        <template  v-for="(item,valor) in attrs" >
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'true'" class="pl-2" color='#FFFFFF'>expand_less</v-icon>
                                            <v-icon :key="valor" v-if="valor == 'aria-expanded' &&  item == 'false'" class="pl-2" color='#FFFFFF'>expand_more</v-icon>
                                        </template>
                                    </v-btn>
                                    
                                </template>
                                <div class="btnAccionesContenedor">
                                    <div @click="abrirModalReporte()" class="btnAccionesItem py-2">
                                        <span>Descargar reporte</span>
                                    </div>
                                </div>
                            </v-menu>
                        </template>

                        <template slot="filters">
                            <v-col cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                v-if="rol == 'root'"
                                class="py-0"
                            >
                                <v-autocomplete
                                    outlined
                                    :items="clientes_search"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    persistent-hint
                                    v-model="cliente_value_search"
                                />
                            </v-col>

                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                                v-if="rol == 'root' || rol == 'admin'"
                            >
                                <v-autocomplete
                                    outlined
                                    :items="empresa_search"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Empresa"
                                    persistent-hint
                                    v-model="empresa_value_search"
                                />
                            </v-col>

                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'"
                                class="py-0"
                            >
                                <v-autocomplete
                                    outlined
                                    :items="sucursal_search"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Sucursal"
                                    persistent-hint
                                    v-model="sucursal_value_search"
                                />
                            </v-col>

                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                            >
                                <v-autocomplete
                                    outlined
                                    :items="departamento_search"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Departamento"
                                    persistent-hint
                                    v-model="departamento_value_search"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                            >
                                <v-autocomplete
                                    outlined
                                    :items="roles_search"
                                    item-text="display_name"
                                    item-value="id"
                                    label="Rol"
                                    persistent-hint
                                    v-model="rol_value_search"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                            >
                                <v-text-field
                                    outlined
                                    label="Correo"
                                    v-model="correo_search"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                xs="12"
                                sm="6"
                                md="6"
                                class="py-0"
                            >
                                <v-text-field
                                    outlined
                                    label="Nombre"
                                    v-model="nombre_usuario"
                                ></v-text-field>
                            </v-col>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data" v-show="item.rol_id != rol_sesion">
                                <td> 
                                    <div class="tblPrincipal d-flex">
                                        <div>
                                            <v-avatar>
                                                <img  :src="urlImg + item.profile_picture" width="130px" />
                                            </v-avatar> 
                                        </div>
                                        <div class="my-auto ml-2">
                                            {{ item.nombre }} {{ item.apellido_paterno }}
                                            <div class="tblSecundario">{{ item.email }}</div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>{{ item.nombre_rol }}</div>
                                </td>
                                <td>
                                    <div>{{ item.nombre_empresa }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-menu
                                            buttom
                                            left
                                            class="elevation-0 d-inline"
                                            content-class="mt-0 menuClassAccionesUsuario"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" icon fab dark small class="elevation-0">
                                                    <template v-for="(item, valor) in attrs">
                                                        <v-icon
                                                            :key="valor"
                                                            v-if="valor == 'aria-expanded' && item == 'false'"
                                                            class="pl-2"
                                                            color="#828282"
                                                        >
                                                            more_vert
                                                        </v-icon>
                                                        <v-icon
                                                            :key="valor"
                                                            v-if="valor == 'aria-expanded' && item == 'true'"
                                                            class="pl-2"
                                                            color="#2DB9D1"
                                                        >
                                                            more_vert
                                                        </v-icon>
                                                    </template>
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item @click="abreModal('update', item, 'true')">
                                                    <v-list-item-title>
                                                        Restaurar contraseña
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="openModalMenu(item)"
                                                    v-if="item.rol_name != 'checador'"
                                                >
                                                    <v-list-item-title>Privilegios - Vistas</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="openModalPermissions(item)"
                                                >
                                                    <v-list-item-title>Permisos</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="abreModal('update', item)"
                                                >
                                                    <v-list-item-title>Editar</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="eliminar(item.id, item.email)"
                                                    v-if="permisos.delete"
                                                >
                                                    <v-list-item-title>Eliminar</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <v-layout row justify-center>
            <v-dialog v-model="dialog" persistent max-width="650px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-toolbar-title v-on="on">
                        <v-btn v-on="on" class="botonModal" id="btnmodal"></v-btn>
                    </v-toolbar-title>
                </template>

                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <v-card-title class="justify-center card_titulo">
                            <div class="headerModal">
                                <img :src="imagen" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto">
                            <div id="loadingModal" v-show="!finaliza_carga">
                                <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-text-field
                                            outlined
                                            id="primero"
                                            autofocus
                                            label="Nombre(s)"
                                            v-model="usuario.nombre"
                                            autocomplete="off"
                                            v-validate="'required'"
                                            data-vv-name="Nombre"
                                            :error-messages="errors.collect('Nombre')"
                                            auto
                                            required
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Apellido paterno"
                                            v-model="usuario.apellido_paterno"
                                            required
                                            autocomplete="off"
                                            v-validate="'required'"
                                            data-vv-name="Apellido paterno"
                                            :error-messages="errors.collect('Apellido paterno')"
                                            auto
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Apellido materno"
                                            v-model="usuario.apellido_materno"
                                            autocomplete="off"
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Teléfono"
                                            v-model="usuario.telefono"
                                            v-mask="'(###) ###-####'"
                                            v-validate="'required'"
                                            data-vv-name="Telefono"
                                            :error-messages="errors.collect('Telefono')"
                                            auto
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Teléfono de oficina"
                                            v-mask="'(###) ###-####'"
                                            v-model="usuario.telefono_oficina"
                                            autocomplete="off"
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Email"
                                            v-model="usuario.email"
                                            id="email"
                                            autocomplete="off"
                                            v-validate="'email'"
                                            data-vv-name="Email"
                                            :error-messages="errors.collect('Email')"
                                            auto
                                        />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Usuario"
                                            v-model="usuario.usuario"
                                            required
                                            id="usuario"
                                            autocomplete="off"
                                            v-validate="'required'"
                                            data-vv-name="Usuario"
                                            :error-messages="errors.collect('Usuario')"
                                            auto
                                        />
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                        <v-autocomplete
                                            outlined
                                            :items="roles"
                                            item-text="display_name"
                                            item-value="id"
                                            label="Rol"
                                            persistent-hint
                                            v-model="rol_value"
                                            v-validate="'required'"
                                            data-vv-name="Rol"
                                            :error-messages="errors.collect('Rol')"
                                        />         
                                    </v-col>

                                    <template
                                        v-if="
                                            (rol_name == 'checador' ||
                                            rol_name == 'admin-depto' ||
                                            rol_name == 'admin-sucursal' ||
                                            rol_name == 'admin-empresa' ||
                                            rol_name == 'admin') &&
                                            rol == 'root'
                                        "
                                    >
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Cliente"
                                                persistent-hint
                                                v-model="cliente_value"
                                                v-validate="'required'"
                                                data-vv-name="Cliente"
                                                :error-messages="errors.collect('Cliente')"
                                            />
                                        </v-col>
                                    </template>

                                    <template
                                        v-if="
                                            (rol_name == 'checador' ||
                                            rol_name == 'admin-depto' ||
                                            rol_name == 'admin-sucursal' ||
                                            rol_name == 'admin-empresa') &&
                                            (rol == 'root' || rol == 'admin')
                                        "
                                    >
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Empresa"
                                                persistent-hint
                                                v-model="empresa_value"
                                                v-validate="'required'"
                                                data-vv-name="Empresa"
                                                :error-messages="errors.collect('Empresa')"
                                            />
                                        </v-col>
                                    </template>

                                    <template
                                        v-if="
                                            (rol_name == 'checador' ||
                                            rol_name == 'admin-sucursal') &&
                                            (rol == 'root' ||
                                                rol == 'admin' ||
                                                rol == 'admin-empresa')
                                        "
                                    >
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="sucursales"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Sucursal"
                                                persistent-hint
                                                v-model="sucursal_value"
                                                v-validate="'required'"
                                                data-vv-name="Sucursal"
                                                :error-messages="errors.collect('Sucursal')"
                                            />
                                        </v-col>
                                    </template>
                                    <template
                                        v-if="
                                            (rol_name == 'admin-depto') &&
                                            (rol == 'root' ||
                                                rol == 'admin' ||
                                                rol == 'admin-empresa')
                                        "
                                    >
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-select
                                                v-model="sucursalesModel"
                                                :items="sucursalesItems"
                                                outlined
                                                chips
                                                deletable-chips
                                                hide-selected
                                                item-text="nombre"
                                                item-value="id"
                                                label="Sucursales"
                                                multiple
                                                v-validate="'required'"
                                                data-vv-name="Sucursal"
                                                :error-messages="errors.collect('Sucursal')"
                                            ></v-select>
                                            <!-- 
                                            <span
                                                class="invalid-feedback color_rojo"
                                                v-if="error_sucursal"
                                                style="display:block"
                                                >Es requerido al menos una sucursal.
                                            </span> 
                                            -->
                                        </v-col>
                                    </template>

                                    <template
                                        v-if="
                                            rol_name == 'admin-depto' &&
                                            (rol == 'root' ||
                                                rol == 'admin' ||
                                                rol == 'admin-empresa' ||
                                                rol == 'admin-sucursal')
                                        "
                                    >
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-select
                                                v-model="departamentos_value"
                                                :items="departamentos"
                                                outlined
                                                chips
                                                deletable-chips
                                                hide-selected
                                                item-text="nombre"
                                                item-value="id"
                                                label="Departamentos"
                                                multiple
                                            ></v-select>
                                        </v-col>
                                        <span
                                            class="invalid-feedback color_rojo"
                                            v-if="error_depto"
                                            style="display:block"
                                            >Es requerido al menos un departamento.
                                        </span>
                                    </template>

                                    <!-- <template
                                        v-if="
                                            rol_value == 6 &&
                                            (rol == 'root' ||
                                                rol == 'admin' ||
                                                rol == 'admin-empresa' ||
                                                rol == 'admin-sucursal')
                                        "
                                    >
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="departamentos"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Departamento"
                                                persistent-hint
                                                v-model="usuario.departamento_id"
                                                v-validate="'required'"
                                                data-vv-name="Departamento"
                                                :error-messages="errors.collect('Departamento')"
                                            />
                                        </v-col>
                                    </template> -->
                                    <!--IMAGEN USUARIO-->
                                    <template v-if="accion === 'add'">
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-menu offset-y elevation="0" content-class="menuClassFoto" z-index="999">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-model="archivo_adjunto"
                                                        outlined
                                                        label="Foto empleado"
                                                        type="text"
                                                        hide-details
                                                        readonly
                                                        class="outer-img"
                                                    > 
                                                        <template slot="append">
                                                            <v-icon v-bind="attrs" v-on="on">arrow_drop_down</v-icon>
                                                        </template>
                                                        <template slot="append-outer">
                                                            <v-avatar>
                                                                <img id="img" src="/static/avatar/usuario4.jpg" width="130px" />
                                                            </v-avatar>
                                                        </template>
                                                    </v-text-field>                                                                    
                                                </template>
                                                <v-text-field
                                                    outlined
                                                    id="form"
                                                    readonly
                                                    label="Adjuntar desde galería"
                                                    @click="almacenarImagen"
                                                    v-model="nombreImagen"
                                                    hide-details
                                                    class="pt-2 v-text-field-foto"
                                                >
                                                    <template slot="append">
                                                        <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                                    </template>
                                                </v-text-field>
                                                <input
                                                    type="file"
                                                    style="display: none"
                                                    ref="imagen"
                                                    accept="image/*"
                                                    id="avatar"
                                                    @change="onFilePickedImagen"
                                                />
                                            
                                            
                                                <v-text-field
                                                    outlined
                                                    id="form2"
                                                    readonly
                                                    label="Tomar fotografía"
                                                    @click="abrirModalFoto('capturar')"
                                                    v-model="nombreFoto"
                                                    hide-details
                                                    class="pt-2 v-text-field-foto"
                                                >
                                                    <template slot="append">
                                                        <v-icon @click="abrirModalFoto('capturar')" class="tamIcono invertirColor" >camera_alt</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </v-menu>
                                        </v-col>
                                       
                                    </template>
                                    <template v-if="accion === 'update'">
                                        <template>
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-menu offset-y elevation="0" content-class="menuClassFoto" z-index="999">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            v-model="archivo_adjunto"
                                                            outlined
                                                            label="Foto empleado"
                                                            type="text"
                                                            hide-details
                                                            readonly
                                                            class="outer-img"
                                                        > 
                                                            <template slot="append">
                                                                <v-icon v-bind="attrs" v-on="on">arrow_drop_down</v-icon>
                                                            </template>
                                                            <template slot="append-outer">
                                                                    <v-avatar>
                                                                        <img id="img" :src="usuario.foto" width="130px" />
                                                                    </v-avatar>
                                                                </template>
                                                        </v-text-field>                                                                    
                                                    </template>
                                                    <v-text-field
                                                        outlined
                                                        id="form"
                                                        readonly
                                                        label="Adjuntar desde galería"
                                                        @click="almacenarImagen"
                                                        v-model="nombreImagen"
                                                        hide-details
                                                        class="pt-2 v-text-field-foto"
                                                    >
                                                        <template slot="append">
                                                            <v-icon @click="almacenarImagen" class="tamIcono">attach_file</v-icon>
                                                        </template>
                                                    </v-text-field>
                                                    <input
                                                        type="file"
                                                        style="display: none"
                                                        ref="imagen"
                                                        accept="image/*"
                                                        id="avatar"
                                                        @change="onFilePickedImagen"
                                                    />
                                                
                                                
                                                    <v-text-field
                                                        outlined
                                                        id="form2"
                                                        readonly
                                                        label="Tomar fotografía"
                                                        @click="abrirModalFoto('capturar')"
                                                        v-model="nombreFoto"
                                                        hide-details
                                                        class="pt-2 v-text-field-foto"
                                                    >
                                                        <template slot="append">
                                                            <v-icon @click="abrirModalFoto('capturar')" class="tamIcono invertirColor" >camera_alt</v-icon>
                                                        </template>
                                                    </v-text-field>
                                                </v-menu>
                                            </v-col>
                                        </template>
                                    </template>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModal()"
                                :disabled="loading_guardar"
                            >
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="veeValidate()"
                                :loading="loading_guardar"
                                v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                            >
                                Guardar
                            </v-btn>
                        </v-card-actions>
                        <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                            <v-alert
                                dense
                                outlined
                                type="error"
                                
                            >
                                El usuario no tiene permiso para editar el registro.
                            </v-alert>
                        </div>

                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </v-layout>

        <v-row>
            <v-dialog
                v-model="dialogTree"
                persistent
                max-width="600px"
                style="max-height: 800px;"
                scrollable
            >
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnmodalTree"></v-btn>
                </template>
                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <v-card-title class="justify-center card_titulo">
                            <div class="headerModal">
                                <img :src="imagen" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto pb-8">
                            <div id="loadingModal" v-show="loading">
                                <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container grid-list-md id="contenedor" v-show="!loading">
                                <v-divider class="my-6"></v-divider>

                                <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="px-5">
                                        <draggable 
                                            v-model="menuConfig.menuUsuario" 
                                            :options="{ group: { name: 'gf1', put: 'gf1'}, animation: 300 } " 
                                        >
                                            <template v-for="(item, index) in menuConfig.menuUsuario">
                                                <template v-if="true/*item.sistema == 'nomina'*/">
                                                    <v-layout
                                                        :key="item.id"
                                                        row
                                                        v-if="item.children.length == 0"
                                                    >
                                                        <div
                                                            style="position: relative; width: 100px; height: 40px;"
                                                        >
                                                            <input
                                                                :id="'chkP' + item.id"
                                                                type="checkbox"
                                                                class="ck-checkbox"
                                                                v-model="item.active"
                                                            />
                                                            <label :for="'chkP' + item.id" class="ck-label">
                                                                {{ item.name }}
                                                            </label>
                                                        </div>
                                                    </v-layout>

                                                    <v-layout row :key="item.id" v-else>
                                                        <div
                                                            style="position: relative; width: 100px; height: 40px;"
                                                        >
                                                            <input
                                                                :id="'chkP' + item.id"
                                                                type="checkbox"
                                                                class="ck-checkbox"
                                                                @click="_selectedAll(item, item.type, index)"
                                                                v-model="item.active"
                                                            />
                                                            <label class="ck-label" :for="'chkP' + item.id">
                                                                {{ item.name }}
                                                            </label>
                                                        </div>

                                                        <div class="checkbox-container">
                                                            <draggable 
                                                                v-model="item.children" 
                                                                :options="{ group: { name: 'gc' + item.id, put: 'gc' + item.id}, animation: 300 } " 
                                                            >
                                                                <template v-for="child in item.children">
                                                                    <div
                                                                        :key="child.id"
                                                                        style="position: relative; width: 100px; height: 40px;"
                                                                    >
                                                                        <input
                                                                            :id="'chkC' + child.id"
                                                                            class="ck-checkbox"
                                                                            type="checkbox"
                                                                            @click="
                                                                                _selectedAll(item, child.type, index, child)
                                                                            "
                                                                            v-model="child.active"
                                                                        />
                                                                        <label :for="'chkC' + child.id" class="ck-label">
                                                                            {{ child.name }}
                                                                        </label>
                                                                    </div>
                                                                </template>
                                                            </draggable>
                                                        </div>
                                                    </v-layout>
                                                </template>
                                            </template>
                                        </draggable>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button class="btnCerrar" @click="cerrarModal()">
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="updateMenu()"
                                :loading="loading_guardar"
                            >
                                Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>

            <v-dialog v-model="dialogReporte" persistent max-width="700px" class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModalReporte"></v-btn>
                </template>
                <v-card class="borde-card">
                        <v-card-title class="card_titulo padding_derecho padding_izquierdo pb-5">
                            <div class="headerModal-filter">
                                <h2 class="titleModal">{{ "Descargar reporte" }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto">
                            <div id="padre" v-if="isLoadingModal" class="d-flex justify-center">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            
                            <v-container v-if="!isLoadingModal" grid-list-md id="contenedor">
                                <v-row class="pt-0 mt-0">
                                    <template v-if="rol == 'root'">
                                        <v-col xs="12" sm="6" md="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="clientes_search"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Cliente"
                                                persistent-hint
                                                v-model="cliente_value_search"
                                            ></v-autocomplete>
                                        </v-col>
                                    </template>

                                    <template v-if="(rol == 'root' || rol == 'admin')">
                                        <v-col xs="12" sm="6" md="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="empresa_search"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Empresa"
                                                persistent-hint
                                                v-model="empresa_value_search"
                                            ></v-autocomplete>
                                        </v-col>
                                    </template>

                                    <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                        <v-col xs="12" sm="6" md="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="sucursal_search"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Sucursal"
                                                persistent-hint
                                                v-model="sucursal_value_search"
                                            ></v-autocomplete>
                                        </v-col>
                                    </template>

                                    <v-col xs="12" sm="6" md="6" class="py-0">
                                        <v-autocomplete
                                            outlined
                                            :items="roles_search"
                                            item-text="display_name"
                                            item-value="id"
                                            label="Rol"
                                            persistent-hint
                                            v-model="rol_value_search"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModalReporte()" 
                                :disabled="loadingReporte"
                            >
                                Cerrar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="descargarReporte()"
                                :loading="loadingReporte"
                            >
                                Descargar
                            </v-btn>
                        </v-card-actions>
                </v-card>
            </v-dialog>

            
            <v-dialog v-model="dialogFoto" persistent max-width="450px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" style="display: none;" class="botonModal" id="btnModalFoto"></v-btn>
                </template>
                <v-card>
                    <div>
                        <v-btn
                            @click="cerrarModalFoto()"
                            small
                            slot="activator"
                            icon
                            text
                            class="v-btn-cerrar pull-right mr-3 mt-3"
                        >
                            <v-icon class="icono-cerrar"></v-icon>
                        </v-btn>
                    </div>
                    <v-card-title>
                        <img src="/static/icon/webcam.png" class="imgChecador" />
                        <h3 class="tituloChecador">Tomar foto</h3>
                    </v-card-title>
                    <v-card-text>
                        <template style="paddin-left:30%">
                            <v-autocomplete
                                :items="devices"
                                item-text="label"
                                item-value="deviceId"
                                class="estiloFoto py-0 my-0"
                                label="Webcam"
                                persistent-hint
                                v-model="camera"
                            >
                                <template class="pa-0 ma-0" slot="prepend-inner">
                                    <v-icon class="tamIcono invertirColor">camera_alt</v-icon>
                                    <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                                </template>
                            </v-autocomplete>
                        </template>

                        <template v-if="imgFoto == null">
                            <div
                                class="center el-video"
                                style="position: relative; height: 250px; display: flex; align-items: center; padding: 0px 65px;"
                            >
                                <web-cam
                                    id="video"
                                    ref="webcam"
                                    height="200"
                                    width="250"
                                    class="webcam"
                                    :device-id="deviceId"
                                    @started="onStarted"
                                    @stopped="onStopped"
                                    @error="onError"
                                    @cameras="onCameras"
                                    @camera-change="onCameraChange"
                                />
                            </div>
                        </template>
                        <template v-else>
                            <v-flex
                                class="center"
                                style="position: relative; height: 200px; display: flex; align-items: center; padding: 0px 65px;"
                            >
                                <img :src="imgFoto" style="height :200px; width: 250px" class="webcam img-responsive"/>
                            </v-flex>
                        </template>
                        <div  v-if="imgFoto == null" class="col-md-12 d-flex justify-center">
                            <v-btn  class="btn-capturar" @click="onCapture">Capturar</v-btn>
                        </div>
                        <div v-else class="col-md-12 d-flex flex-column mx-auto" style="max-width: 200px;">
                            <v-btn class="btn-capturar" @click="guardaFoto">Guardar</v-btn>
                            <v-btn class="btn-omitir" id="no-background-hover" @click="omitirFoto()">Tomar nueva foto</v-btn>
                        </div>
                    </v-card-text>
                    <v-card-actions>

                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogPermissions" scrollable persistent max-width="600px" class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <v-card class="borde-card">
                    <div class="card_texto">
                        <h2 class="titleModal mt-5">Permisos</h2>
                        <v-col  cols="12" xs="12" sm="12" md="12" class="pa-0 pt-2">
                            <v-text-field
                                outlined
                                label="Buscar"
                                prepend-inner-icon="mdi-magnify"
                                v-model="busqueda"
                            ></v-text-field>
                        </v-col>
                    </div>
                    
                    <v-card-text class="card_texto" style="height: 80%;">
                        <v-container grid-list-md id="contenedor">
                            <v-row class="pa-0 ma-0">
                                <v-col v-if="loadingPermissions" cols="12" xs="12" sm="12" md="12" class="pa-5 ma-0 text-center">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </v-col>
                                <template v-else>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 ma-0">
                                        <div v-for="item in itemsPermissionsUserFiltered" :key="item.categoria.nombre">
                                            <div class="categoria">{{item.categoria.displayName}}</div>
                                            <div class="ma-0 ml-3 pa-2">
                                                <div v-for="permiso in item.permisos" class="pa-0 ma-0">
                                                    <v-checkbox
                                                        v-model="permiso.checked"
                                                        :label="permiso.title + ' - ' + permiso.description"
                                                        :value="permiso.checked"
                                                        class="pa-0 ma-0"
                                                    ></v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions v-if="!loadingPermissions" class="d-flex justify-end card_accion" >
                        <button
                            class="btnCerrar"
                            @click="cerrarModalPermissions()" 
                            :disabled="isSaving"
                        >
                            Cancelar
                        </button>
                        <v-btn
                            class="btnGuardar"
                            @click="guardarPermissions()" 
                            :loading="isSaving"
                        >
                            Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>


    </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

import userApi from "../api/usuarios";
import rolApi from "../api/roles";
import clienteAPi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import apiPermisos from "@/api/permisos";
import Datatable from "@/components/datatable/Datatable.vue";
import { delimiter } from "path";
import Multiselect from "vue-multiselect";
import PerfectScrollbar from "perfect-scrollbar";
import draggable from "vuedraggable";
import {WebCam} from "vue-web-cam";
import GetUrlImg from "@/plugins/Urlimagen";
import VuetifyMultipleAutocomplete2 from '@/components/VuetifyMultipleAutocomplete2'

export default {
    components: {
        Multiselect,
        "data-table": Datatable,
        draggable,
        "web-cam" : WebCam,
        "multi-autocomplete": VuetifyMultipleAutocomplete2
    },
    data() {
        return {
            url: "usuarios/find",
            columns: [
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Rol", name: "rol", filterable: true },
                { label: "Empresa", name: "empresa", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ],
            filters: {
                include_padres  : true,
                activo          : true,
                paginate        : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                empleado_id     : null,
                rol_id          : null,
                order_by        : 'nombre'
            },

            cliente_value_search    : null,
            empresa_value_search    : null,
            sucursal_value_search   : null,
            departamento_value_search: null,
            rol_value_search        : null,

            loading_guardar         : false,
            dialog                  : false,
            dialogTree              : false,
            dialogBusqueda          : false,
            loading                 : true,
            datosLogin              : "",

            titulo_modal            : "",
            usuario: {
                id              : "",
                nombre          : "",
                apellido_paterno: "",
                apellido_materno: "",
                telefono_oficina: "",
                telefono        : "",
                email           : "",
                usuario         : "",
                password        : "123456",
                cliente_id      : null,
                rol_id          : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                email_anterior  : null,
                departamentos   : [],
                foto            : null,
            },
            accion                  : "",
            roles                   : [],
            clientes_search         : [],
            empresa_search          : [],
            sucursal_search         : [],
            departamento_search     : [],
            roles_search            : [],
            correo_search           : null,
            rol                     : "",
            clientes                : [],
            empresas                : [],
            sucursales              : [],
            departamentos           : [],
            carga_final             : 0,
            finaliza_carga          : false,
            cliente_value           : null,
            empresa_value           : null,
            sucursal_value          : null,
            rol_value               : null,
            rol_sesion              : null,
            nombre_usuario          : null,
            menuConfig              : {
                id_usuario  : null,
                menuUsuario : [],
            },
            departamentos_value     : [],
            departamentos_id        : false,
            departamento_id         : null,
            error_depto             : false,
            imagen                  : "/static/modal/usuarioCreate.svg",
            showSucursales          : false,
            error_sucursal          : false,
            sucursalesModel         : [],
            sucursalesItems         : [],
            departamentosItemsUpdate: [],
            sucursalesItemsUpdate   : [],
            abrirModalUpdate        : true,
            dialogReporte           : false,
            isLoadingModal          : false,
            loadingReporte          : false,
            loadingLottie           : false,
            fraseLoading            : '',
            archivo_adjunto         : null,
            nombreImagen            : "",
            nombreFoto              : "",
            archivoImagen           : null,
            showMenu                : false,
            imgFoto                 : null,
            dialogFoto              : false,
            devices                 : [],
            camera                  : null,
            deviceId                : null,
            urlImg                  : null,
            rol_name                : null,
            todos_los_roles        : [],
            dialogPermissions: false,
            loadingPermissions: false,
            isSaving: false,
            userPermissions: null,
            itemsPermissionsUser: [],
            busqueda: "",
            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        };
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        cliente_value_search: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val, oldVal) {
            if(val != null){
                
                if(this.rol_name == 'admin-depto'){
                    if(oldVal != null){
                        this.sucursalesModel = [];
                        this.departamentos_value = [];
                    }
                    this.getSucursalesDeptos(val);
                }
                else {
                    this.cambiaEmpresa(val);
                }
            }
        },
        empresa_value_search: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
        sucursal_value: function(val) {
            if(val != null){
                this.departamentos_value = [];
                this.cambiaSucursal(val);
            }
        },
        sucursal_value_search: function(val) {
            if(val != null){
                this.cambiaSucursal(val);
            }
        },
        /* rol_value: function(val, oldVal) {
            if (val == 2) { //admin
                this.empresa_value = null;
                this.sucursal_value = null;
                this.usuario.departamentos = [];
                this.usuario.departamento_id = null;
            } else if (val == 3) { //admin-empresa
                this.sucursal_value = null;
                this.usuario.departamentos = [];
                this.usuario.departamento_id = null;
            } else if (val == 4) { //admin-sucursal
                this.usuario.departamentos = [];
                this.usuario.departamento_id = null;
                if(this.rol == 'admin-empresa'){
                    this.cambiaEmpresa(this.datosLogin.empresa_id)
                }
                
            }else if(val == 6){ //empleado
                if(this.rol == 'admin-empresa'){
                    this.cambiaEmpresa(this.datosLogin.empresa_id)
                }  
            }
            
            this.showSucursales = (val == 5 ? true:false); 

            if(oldVal != null && val == 5) {
                if(this.empresa_value !=null){
                    this.getSucursalesDeptos(this.empresa_value);
                    this.sucursalesModel = [];
                    this.departamentos_value = [];
                   
                }
                if(this.rol == 'admin-sucursal'){
                    this.cambiaSucursal(this.datosLogin.sucursal_id)
                } 
            }
        }, */
        rol_value : function(val){
            if(val != null){
                this.todos_los_roles.forEach(item => {
                    if(item.id == val){
                        this.rol_name = item.name
                        return
                    }
                })
            }
        },
        rol_name: function(val, oldVal) {
            //console.log('rol_name: ', val)
            if (val == 'admin') { //admin
                this.empresa_value = null;
                this.sucursal_value = null;
                this.usuario.departamentos = [];
                this.usuario.departamento_id = null;
            } else if (val == 'admin-empresa') { //admin-empresa
                this.sucursal_value = null;
                this.usuario.departamentos = [];
                this.usuario.departamento_id = null;
            } else if (val == 'admin-sucursal') { //admin-sucursal
                this.usuario.departamentos = [];
                this.usuario.departamento_id = null;
                if(this.rol == 'admin-empresa'){
                    this.cambiaEmpresa(this.datosLogin.empresa_id)
                }
                
            }else if(val == 'empleado'){ //empleado
                if(this.rol == 'admin-empresa'){
                    this.cambiaEmpresa(this.datosLogin.empresa_id)
                }  
            }
            
            this.showSucursales = (val == 'admin-depto' ? true:false); 

            if(oldVal != null && val == 'admin-depto') {
                if(this.empresa_value !=null){
                    this.getSucursalesDeptos(this.empresa_value);
                    this.sucursalesModel = [];
                    this.departamentos_value = [];
                   
                }
                if(this.rol == 'admin-sucursal'){
                    this.cambiaSucursal(this.datosLogin.sucursal_id)
                } 
            }
        },
        sucursalesModel: function(val){
            this.departamentos = [];
            for(let suc = 0; suc < this.sucursalesModel.length; suc++){
                let evaluarSucursal = this.sucursalesItems.find(element => element.id == this.sucursalesModel[suc]);
                for(let depto = 0 ; depto < evaluarSucursal.departamentos.length; depto++){
                    this.departamentos.push(evaluarSucursal.departamentos[depto]);
                }
            }

            let departamentos_ids = [];
            for(let valDepto = 0; valDepto < this.departamentos_value.length; valDepto++){
                for(let suc = 0; suc < this.sucursalesModel.length; suc++){
                    let evaluarSucursal = this.sucursalesItems.find(element => element.id == this.sucursalesModel[suc]);
                    for(let depto = 0 ; depto < evaluarSucursal.departamentos.length; depto++){
                        if (evaluarSucursal.departamentos[depto].id == this.departamentos_value[valDepto])
                        departamentos_ids.push(this.departamentos_value[valDepto])
                    }
                }
            }
            this.departamentos_value = departamentos_ids;
        },
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        },
    },
    methods: {
        ...mapActions("auth", ["update_cliente", "notificacion"]),
        Cambio_depto(){
            //this.departamentos_id = true;
        },
        Cambio_sucursal(){

        },
        listar(parametros = null) {
            this.resetValue();
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
            this.urlImg = GetUrlImg.getURL();
        },
        eliminar(id, usuario) {
            let self = this;

            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el usuario?",
                "Eliminar",
                () => {
                    userApi.deleteUsuario(id).then((response) => {
                        self.$refs.tableUsuarios.getData();
                        self.listar();
                        Notify.Success(
                            "Usuario eliminado",
                            "El usuario ha sido eliminado satisfactoriamente."
                        );
                    })
                    .catch((err) => {
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            );
        },
        resetPass(data = null) {
            let self = this;

            Notify.Restore(
                "¿Quieres restaurar contraseña?",
                null,
                "Restaurar",
                () => {
                    self.usuario.password = "123456";
                    self.usuario.primer_inicio_sesion = true;
                    self.usuario.rol_id = self.rol_value;

                    userApi.updatePassword(self.usuario).then((response) => {
                        Notify.Success(
                            "Contraseña restaurada",
                            "La contraseña se restauró satisfactoriamente."
                        );
                    })
                    .catch((error) => {
                        console.error(err);
                        this.respuesta_error(err);
                    });
                }
            );
        },
        async abreModal(accion, data = null, pass = null) {
            this.errors.clear();
            await this.resetValue();
            this.accion = accion;
            
            $("#primero").focus();

            if (accion == "add") {
                this.titulo_modal = "Registro de usuario";
                this.imagen = "/static/modal/usuarioCreate.svg";
                this.finaliza_parametros();
            } 
            else if (accion == "update") {
                this.titulo_modal               = "Actualización de usuario";
                this.imagen                     = "/static/modal/usuarioUpdate.svg";
                this.usuario.id                 = data.id;
                this.usuario.nombre             = data.nombre;
                this.usuario.apellido_paterno   = data.apellido_paterno;
                this.usuario.apellido_materno   = data.apellido_materno;
                this.usuario.telefono_oficina   = data.telefono_oficina;
                this.usuario.telefono           = data.telefono;
                this.usuario.email              = data.email;
                this.usuario.email_anterior     = data.email;
                this.usuario.usuario            = data.usuario;
                this.usuario.foto               = this.urlImg + data.profile_picture;
                this.rol_value                  = data.rol_id;
                this.sucursalesItemsUpdate      = data.sucursales;
                this.departamentosItemsUpdate   = data.departamentos;
                this.usuario.cliente_id         = data.cliente_id;
                this.usuario.empresa_id         = data.empresa_id;
                this.usuario.sucursal_id        = data.sucursal_id;
                this.usuario.departamento_id    = data.departamento_id;

                /* let depto = [];

                data.departamentos.forEach((element) => {
                    depto.push({
                        id: element["departamento_id"],
                        nombre: element["nombre"],
                    });
                });
                this.usuario.departamentos = depto; */
            }

            if (pass == null) {
                this.getRoles(this.rol, this.accion);
                if (this.rol == "root") {
                    this.getClientes(this.usuario.cliente_id);
                }

                if (this.rol == "admin") {
                    this.cambiaCliente(
                        this.datosLogin.cliente_id,
                        this.usuario.empresa_id
                    );
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.finaliza_parametros();
                    this.finaliza_parametros();
                }

                if (this.rol == "admin-empresa") {
                    //this.cambiaEmpresa(this.datosLogin.empresa_id, this.accion);
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.getSucursalesDeptos(this.datosLogin.empresa_id)
                    this.finaliza_parametros();
                    this.finaliza_parametros();
                }

                if (this.rol == "admin-sucursal") {
                    this.cambiaSucursal(this.datosLogin.sucursal_id, this.accion);
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                    this.finaliza_parametros();
                    this.finaliza_parametros();
                }

                if (this.rol == "admin-depto") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                    this.usuario.departamento_id = this.datosLogin.departamento_id;
                    this.finaliza_parametros();
                    this.finaliza_parametros();
                    this.finaliza_parametros();
                }

                document.getElementById("btnmodal").click();
            } else {
                this.resetPass();
            }
        },
        openModalMenu(data) {
            this.menuConfig.id_usuario = data.id;
            this.imagen = "/static/modal/privilegios.svg";
            this.titulo_modal = "Privilegios";
            this.loading = true;

            //API DE CONSULTA DE MENU DEL USUARIO
            userApi.getMenu(data.id).then(async (response) => {
                this.menuConfig.menuUsuario = await this.createMenuData(
                    this.menu,
                    response
                );
                this.loading = false;
            })
            .catch((error) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los munus del usuario.");
            });

            document.getElementById("btnmodalTree").click();
        },
        createMenuData(arrayParent, arrayUser) {
            var newArray = [];

            for (var i = 0; i < arrayParent.length; i++) {
                let arrayChild = [];
                let boolParent = false;
                let itemMenu = arrayParent[i];
                let arrayParentFilter = arrayUser.filter((element) => element.valor == itemMenu.valor);

                if (arrayParentFilter.length > 0) {
                    boolParent = true;
                }

                if (itemMenu.hijos) {
                    for (var y = 0; y < itemMenu.hijos.length; y++) {
                        let itemChild = itemMenu.hijos[y];
                        let boolChild = false;
                        let arrayFilterChild =
                        arrayParentFilter.length > 0
                            ? arrayParentFilter[0].hijos.filter(
                                (element) => itemChild.valor == element.valor
                            )
                            : [];

                        if (arrayFilterChild.length > 0) {
                            boolChild = true;
                        }

                        arrayChild.push({
                            id: itemChild.id,
                            name: itemChild.nombre,
                            valor: itemChild.valor,
                            type: itemChild.tipo,
                            active: boolChild,
                        });
                    }
                }

                newArray.push({
                    id: itemMenu.id,
                    name: itemMenu.nombre,
                    valor: itemMenu.valor,
                    type: itemMenu.tipo,
                    active: boolParent,
                    children: arrayChild,
                });
            }

            return newArray;
        },
        _selectedAll(data, type, index, child) {
            if (type == "M") {
                let newValue = !data.active ? true : false;

                for (let i = 0; i < data.children.length; i++) {
                    let item = data.children[i];
                    item.active = newValue;
                    data.children.splice(i, 1, item);
                }
            } 
            else {
                if (!child.active) {
                    data.active = !false;
                    this.menuConfig.menuUsuario.splice(index, 1, data);
                    return;
                }

                let arrayFilter = data.children.filter((element) => element.active == false);
                if (arrayFilter.length + 1 == data.children.length) {
                    data.active = false;
                    this.menuConfig.menuUsuario.splice(index, 1, data);
                }
            }
        },
        updateMenu() {
            this.loading_guardar = true;
            var params = {
                usuario_id: this.menuConfig.id_usuario,
                vistas: [],
            };

            for (var i = 0; i < this.menuConfig.menuUsuario.length; i++) {
                let itemParent = this.menuConfig.menuUsuario[i];
                if (itemParent.active) {
                    params.vistas.push({ vista_id: itemParent.id });
                    if (itemParent.children) {
                        for (var j = 0; j < itemParent.children.length; j++) {
                            let itemChild = itemParent.children[j];
                            if (itemChild.active) {
                                params.vistas.push({ vista_id: itemChild.id });
                            }
                        }
                    }
                }
            }
            params.vistas = JSON.stringify(params.vistas);
            userApi.updateMenu(params).then(async (response) => {
                this.cerrarModal("cerrar");
                Notify.Success("Operación exitosa", response.message);
            })
            .catch((err) => {
                this.respuesta_error(err);
            });
        },
        async loadModalData() {
            await this.resetValue();
            if (this.rol == "root") {
                this.getClientes();
            } else if (this.rol == "admin") {
                this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.empresa_value_search = this.filters.empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.sucursal_value_search = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                this.departamento_search = this.filters.departamento_id = this.datosLogin.departamento_id;
            }
            var rol_search = this.rol;
            this.getRoles(rol_search, "busqueda");
        },
        setFilters() {
            let cliente = this.cliente_value_search;
            let empresa = this.empresa_value_search;
            let sucursal = this.sucursal_value_search;
            let departamento = this.departamento_value_search;
            let rol = this.rol_value_search;
            let correo = this.correo_search;
            let nombre = this.nombre_usuario

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } 
            else if (this.rol == "admin-empresa") {
                empresa = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin-sucursal") {
                sucursal = this.datosLogin.sucursal_id;
            } 
            else if (this.rol == "admin-depto") {
                departamento = this.datosLogin.departamento_id;
            }

            let filterParams = {
                cliente_id: cliente,
                empresa_id: empresa,
                sucursal_id: sucursal,
                departamento_id: departamento,
                rol_id: rol,
                email: correo,
                nombre: nombre,
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) Object.assign(defaultParams, filterParams);

            this.filters = defaultParams;
            this.cliente_value_search = null;
            this.empresa_value_search = null;
            this.sucursal_value_search = null;
            this.departamento_value_search = null;
            this.rol_value_search = null;
            this.correo_search = null;
        },
        getRoles(rol = null, accion) {
            let self = this;
            let roles = [];
            let param = { is_delete: false, paginate: false, order: "asc" };
            rolApi.getRoles(param).then((response) => {
                let respuesta = response.data;
                if(accion == 'inicio'){
                    this.todos_los_roles = response.data
                    return
                }
                respuesta.forEach((element) => {
                   
                    if (this.datosLogin.rol.name === "root") {
                        if (
                            element["name"] == "admin" ||
                            element["name"] == "admin-empresa" ||
                            element["name"] == "admin-sucursal" ||
                            element["name"] == "admin-depto" ||
                            element["name"] == "checador" ||
                            (element["name"] == "empleado" &&
                            (accion == "update" || accion == "busqueda"))
                        ) {
                            self.roles.push(element);
                            self.roles_search.push(element);
                        }
                    } 
                    else if (this.datosLogin.rol.name === "admin") {
                        if (
                            element["name"] == "admin-empresa" ||
                            element["name"] == "admin-sucursal" ||
                            element["name"] == "admin-depto" ||
                            element["name"] == "checador" ||
                            (element["name"] == "empleado" &&
                            (accion == "update" || accion == "busqueda"))
                        ) {
                            self.roles.push(element);
                            self.roles_search.push(element);
                        }
                    } 
                    else if (this.datosLogin.rol.name === "admin-empresa") {
                        if (
                            element["name"] == "admin-sucursal" ||
                            element["name"] == "admin-depto" ||
                            element["name"] == "checador" ||
                            (element["name"] == "empleado" &&
                            (accion == "update" || accion == "busqueda"))
                        ) {
                            self.roles.push(element);
                            self.roles_search.push(element);
                        }
                    } 
                    else if (this.datosLogin.rol.name === "admin-sucursal") {
                        if (
                            element["name"] == "admin-depto" ||
                            (element["name"] == "empleado" &&
                            (accion == "update" || accion == "busqueda"))
                        ) {
                            self.roles.push(element);
                            self.roles_search.push(element);
                        }
                    }
                    
                });
                    self.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar los roles.");
            });
        },
        getClientes(cliente = null) {
            let self = this;
            let param = { activo: true, paginate: false};
            clienteAPi.getClientes(param).then((response) => {
                this.clientes_search = this.clientes = response.data;
                this.finaliza_parametros();
                if (this.accion == "update") {
                    this.cliente_value = cliente;
                    if (
                    this.rol_name == 'admin-empresa' ||
                    this.rol_name == 'admin-sucursal' ||
                    this.rol_name == 'admin-depto' ||
                    this.rol_name == 'empleado' ||
                    this.rol_name == 'checador'
                    )
                    this.cambiaCliente(cliente, this.usuario.empresa_id);

                    setTimeout(function() {self.finaliza_parametros();}, 300);
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        veeValidate(valido = null) {
            let self = this;
            self.error_depto = false;
            if (valido == null) {
                this.$validator.validate().then((result) => {
                    if (result) {
                        let self = this;
                        this.loading_guardar = true;
                        this.usuario.cliente_id = this.cliente_value;
                        this.usuario.empresa_id = this.empresa_value;
                        this.usuario.sucursal_id = this.sucursal_value;
                        this.usuario.rol_id = this.rol_value;
                        
                        /* 
                        if (this.cliente_value == null) delete this.usuario.cliente_id;

                        if (this.empresa_value == null) delete this.usuario.empresa_id;

                        if (this.sucursal_value == null) delete this.usuario.sucursal_id; */

                        let formData = new FormData()

                        
                        formData.append('nombre', this.usuario.nombre)
                        formData.append('apellido_paterno', this.usuario.apellido_paterno)
                        formData.append('apellido_materno', this.usuario.apellido_materno)
                        formData.append('telefono_oficina', this.usuario.telefono_oficina)
                        formData.append('telefono', this.usuario.telefono)
                        formData.append('email', this.usuario.email)
                        formData.append('usuario', this.usuario.usuario)
                        
                        formData.append('rol_id', this.usuario.rol_id)
                        if(this.usuario.cliente_id != null){
                            formData.append('cliente_id', this.usuario.cliente_id)
                        }
                        if(this.usuario.empresa_id != null){
                            formData.append('empresa_id', this.usuario.empresa_id)
                        }
                        if(this.usuario.sucursal_id != null){
                            formData.append('sucursal_id', this.usuario.sucursal_id)
                        }
                        if(this.usuario.departamento_id != null){
                            formData.append('departamento_id', this.usuario.departamento_id)
                        }
                        if(this.archivoImagen != null){
                            formData.append('profile_picture', this.archivoImagen)
                        }


                        if (this.rol_name == 'admin-depto') {
                            if (this.departamentos_value.length == 0) {
                                self.error_depto = true;
                                this.loading_guardar = false;
                                return;
                            }
                            let depto = [];
                            if(this.accion == "add"){
                                this.departamentos_value.forEach((element) => {
                                    depto.push({
                                        departamento_id: element,
                                    });
                                });
                            } 
                            else if(this.accion == "update"){
                                this.departamentos_value.forEach((element) => {
                                    depto.push({
                                        departamento_id: element,
                                    });
                                });
                            }
                            this.usuario.departamentos = depto;
                            
                        }
                        if (this.rol_name == 'empleado') {
                            this.usuario.departamentos.push(parseInt(this.departamento_id));
                        }

                        console.log(this.usuario.departamentos);

                        formData.append('departamentos', JSON.stringify(this.usuario.departamentos))
                        

                        if (this.accion == "add") {
                            formData.append('password', this.usuario.password)
                            userApi.addUsuario(formData).then((response) => {
                                self.$refs.tableUsuarios.getData();
                                self.listar();

                                this.cerrarModal();
                                Notify.Success(
                                    "Registro de usuario",
                                    "El usuario se guardó satisfactoriamente."
                                );
                            })
                            .catch((err) => {
                                this.loading_guardar = false;
                                this.respuesta_error(err);
                            });
                        } 
                        else if (this.accion == "update") {
                            formData.append('id', this.usuario.id)
                            userApi.updateUsuario(formData).then((response) => {
                                self.$refs.tableUsuarios.getData();
                                self.listar();

                                this.cerrarModal();
                                Notify.Success(
                                    "Modificación de usuario",
                                    "El usuario se modificó satisfactoriamente."
                                );
                            })
                            .catch((err) => {
                                this.loading_guardar = false;
                                this.respuesta_error(err);
                            });
                        }
                    }
                });
            }
        },
        resetValue() {
            this.titulo_modal               = "";
            this.usuario.id                 = "";
            this.usuario.nombre             = "";
            this.usuario.apellido_paterno   = "";
            this.usuario.apellido_materno   = "";
            this.usuario.telefono_oficina   = "";
            this.usuario.email              = "";
            this.usuario.usuario            = "";
            this.usuario.telefono           = "";
            this.usuario.password           = "123456";
            this.usuario.cliente_id         = null;
            this.usuario.rol_id             = null;
            this.usuario.empresa_id         = null;
            this.usuario.sucursal_id        = null;
            this.usuario.departamento_id    = null;
            this.usuario.departamentos      = [];
            this.usuario.foto               = null;
            this.departamentos_id           = false;
            this.rol_value                  = null;
            this.rol_name                   = null
            this.sucursalesModel            = [];
            this.sucursalesItems            = [];
            this.departamentosItemsUpdate   = [];
            this.sucursalesItemsUpdate      = [];
            this.abrirModalUpdate           = true;

            this.accion         = "";
            this.roles          = [];
            this.clientes       = [];
            this.empresas       = [];
            this.sucursales     = [];
            this.departamentos  = [];
            this.carga_final    = 0;
            this.finaliza_carga = false;

            this.cliente_value  = null;
            this.empresa_value  = null;
            this.sucursal_value = null;

            this.usuario.email_anterior = null;
            this.loading_guardar        = false;

            this.cliente_value_search   = null;
            this.empresa_value_search   = null;
            this.sucursal_value_search  = null;
            this.departamento_value_search = null;
            this.rol_value_search       = null;
            this.clientes_search        = [];
            this.empresa_search         = [];
            this.sucursal_search        = [];
            this.departamento_search    = [];
            this.error_depto            = false;
            this.correo_search          = null;   
            this.nombre_usuario         = null;
            $("#avatar").val("");
            $("#texto").text("");
            $("#img").attr(
                "src",
                "/static/avatar/usuario4.jpg"
            );  
            this.archivo_adjunto         = null
            this.nombreImagen            = ""
            this.nombreFoto              = ""
            this.archivoImagen           = null
            this.showMenu                = false
            this.imgFoto                 = null 
                 
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        cerrarModal(menu = null) {
            this.dialogTree = false;
            this.dialog = false;
            this.dialogBusqueda = false;
            this.loading_guardar = false;
            this.resetValue();
        },
        cambiaCliente(cliente, empresa = null) {
            let param = { activo: true, paginate: false, cliente_id: cliente };

            empresaApi.getEmpresas(param).then((response) => {
                this.empresa_search = this.empresas = response.data;
                if (empresa) {
                    this.empresa_value = empresa;
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(empresa, accion = null) {
            let param = { activo: true, paginate: false, empresa_id: empresa };

            sucursalApi.getSucursales(param).then((response) => {
                this.sucursal_search = this.sucursales = response.data;
                if (this.usuario.sucursal_id != null) {
                    this.sucursal_value = this.usuario.sucursal_id;
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        getSucursalesDeptos(empresa, sucursales, departamentos){
            let param = { activo: true, paginate: false, empresa_id: empresa };
            sucursalApi.getSucursalesDepartamentos(param).then((response) => {
                this.sucursalesItems = response;
                if(this.accion == 'update' && this.abrirModalUpdate){
                    this.departamentosItemsUpdate.forEach((element) => {
                        this.departamentos_value.push(element["departamento_id"])
                    })
                    this.sucursalesItemsUpdate.forEach((element) => {
                        this.sucursalesModel.push(element["id"])
                    })

                    this.abrirModalUpdate           = false;
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        cambiaSucursal(sucursal, accion = null) {
            let param = { activo: true, paginate: false, sucursal_id: sucursal };

            departamentoApi.getDepartamentos(param).then((response) => {
                this.departamento_search = this.departamentos = response.data;

                if (this.accion == "update") {
                    /* if (this.rol_value == 5) {
                        this.departamentos_value = this.usuario.departamentos;
                    } */
                    if (this.rol_name == 'empleado') {
                        this.departamento_id = this.usuario.departamento_id;
                    }
                    this.usuario.departamentos = [];
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading_guardar = false;
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            });
        },
        finaliza_parametros() {
            this.carga_final = this.carga_final + 1;
            if (this.carga_final == 3) {
                this.finaliza_carga = true;
            }
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        abrirModalReporte(){
            this.dialogReporte      = true;
            this.loadModalData();
        },
        cerrarModalReporte(){
            this.dialogReporte      = false;
            this.loadingLottie      = false;
            this.fraseLoading       = '';
        },
        descargarReporte(){

            let parametros = { 
                cliente_id  : this.cliente_value_search,
                empresa_id  : this.empresa_value_search,
                sucursal_id : this.sucursal_value_search,
                rol_id      : this.rol_value_search
            }

            if(this.rol == 'root'){
                if(this.cliente_value_search == null || this.cliente_value_search == ''){
                    Notify.ErrorToast("Seleccionar un cliente.");
                    return;
                } 
            }
            else if(this.rol == 'admin'){
                parametros.cliente_id = this.datosLogin.cliente_id;
            }
            else if(this.rol == 'admin-empresa'){
                parametros.cliente_id = this.datosLogin.cliente_id;
                parametros.empresa_id = this.datosLogin.empresa_id;
            }
            else if(this.rol == 'admin-sucursal'){
                parametros.cliente_id = this.datosLogin.cliente_id;
                parametros.empresa_id = this.datosLogin.empresa_id;
                parametros.sucursal_id = this.datosLogin.sucursal_id;
            }
            else if(this.rol == 'admin-depto'){
                parametros.cliente_id = this.datosLogin.cliente_id;
                parametros.empresa_id = this.datosLogin.empresa_id;
                parametros.sucursal_id = this.datosLogin.sucursal_id;
            }
            else{
                parametros.cliente_id = this.datosLogin.cliente_id;
                parametros.empresa_id = this.datosLogin.empresa_id;
                parametros.sucursal_id = this.datosLogin.sucursal_id;
            }

            this.loadingLottie = true;
            this.fraseLoading = 'Descargando';
            const FileDownload = require("js-file-download");
            let nombre;
            nombre = "Reporte_de_usuarios.xlsx";
            let url = "usuarios/reporte-usuarios";
            try {
                Vue.axios({
                    method: "POST",
                    responseType: "blob",
                    url: url,
                    data: parametros,
                }).then((response, status, xhr) => {
                    FileDownload(response.data, nombre);
                    this.loadingLottie = false;
                    this.cerrarModalReporte();
                })
                .catch(async (error)=>{
                    this.loadingLottie = false;
                    let errorString = error.response.data;
                    if (
                        error.request.responseType === 'blob' &&
                        error.response.data instanceof Blob &&
                        error.response.data.type &&
                        error.response.data.type.toLowerCase().indexOf('json') != -1
                    ){
                        errorString = JSON.parse(await error.response.data.text());
                        console.log(errorString)

                        if(typeof errorString.error === 'string'){
                            Notify.ErrorToast(errorString.error);
                        }else{
                            let error = Object.values(errorString.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    }; 
                });
            } 
            catch (err) {
                Notify.ErrorToast("No se pudo realizar la petición");
                console.log(err);
                this.loadingLottie = false;
            }
        },
        onFilePickedImagen(evento) {
            const img = evento.target.files;
            if (img[0] !== undefined) {
                this.archivo_adjunto = this.nombreImagen = img[0].name;
                if (this.nombreImagen.lastIndexOf(".") <= 0) {
                    return;
                }
                const archivo = new FileReader();
                archivo.readAsDataURL(img[0]);
                archivo.addEventListener("load", (e) => {
                    this.archivoImagen = img[0];
                    $("#img").attr("src", e.target.result);
                });
            } 
            else {
                this.nombreImagen = "";
                this.archivoImagen = null;
            }
        },
        almacenarImagen() {
            this.$refs.imagen.click();
            this.showMenu = false;
            this.validarImagen();
        },
        toggleMenu() {
            this.showMenu = true;
        },
        //multiselect
        abrirModalFoto(capturar, item = null) {
            setTimeout(() => { this.$refs.webcam.start();}, 750);
            this.showMenu = false;
            if (capturar == "capturar") {
                document.getElementById("btnModalFoto").click();
            }
            this.imgFoto = null;
        },
        onCapture() {
            this.imgFoto = this.$refs.webcam.capture();
        },
        b64toBlob(base64URL, sliceSize) {
            var arr = base64URL.split(",");
            var contentType = arr[0].match(/:(.*?);/)[1];
            var b64Data = arr[1];
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        guardaFoto(){
            this.$refs.imagen = this.imgFoto;
            $("#img").attr("src", this.imgFoto);
            this.archivo_adjunto = 'Foto1.jpg';
            this.usuario.foto = this.imgFoto;
            console.log(this.archivoImagen);
            this.imgFoto = this.b64toBlob(this.imgFoto);
            const archivo = new FileReader();
                archivo.readAsDataURL(this.imgFoto);
                archivo.addEventListener("load", () => {
                this.archivoImagen = this.imgFoto;
            });
            this.dialogFoto = false;
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
        },
        validarImagen() {
            var self = this;
            //Cuando cambie #avatar
            $("#avatar").change(function() {
                $("#texto").text("");
                $("#img").attr("src", "");
                if (self.validarExtension(this)) {
                    if (self.validarPeso(this)) {
                        self.verImagen(this);
                    }
                }
            });
        },

        validarExtension(datos) {
            //Validacion de estensiones permitidas
            var extensionesValidas = ".png, .gif, .jpeg, .jpg";
            var ruta = datos.value;
            var extension = ruta.substring(ruta.lastIndexOf(".") + 1).toLowerCase();
            var extensionValida = extensionesValidas.indexOf(extension);
            if (extensionValida < 0) {
                Swal.fire({
                    position: "center",
                    type: "error",
                    title: "Error",
                    html:
                        "La extensión no es válida <br> Su fichero tiene de extensión: " +
                        extension,
                    showConfirmButton: true
                }).then(result => {
                    if (result.value) {
                        $("#avatar").val("");
                        $("#form").val("");
                        this.nombreImagen = "";
                        this.archivoImagen = null;
                    }
                });
                return false;
            } else {
                return true;
            }
        },
        validarPeso(datos) {
            var pesoPermitido = 1536;
            if (datos.files && datos.files[0]) {
                var pesoFichero = datos.files[0].size / 1024;
                if (pesoFichero > pesoPermitido) {
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: "Error",
                        html:
                        "El tamaño de la imagen supera el limite permitido!! <br> El peso maximo permitido del fichero es: " +
                        pesoPermitido +
                        " KB Su fichero tiene: " +
                        pesoFichero +
                        " KBs",
                        showConfirmButton: true
                    }).then(result => {
                        if (result.value) {
                            $("#avatar").val("");
                            $("#form").val("");
                            this.nombreImagen = "";
                            this.archivoImagen = null;
                        }
                    });
                    return false;
                } 
                else {
                    return true;
                }
            }
        },
        verImagen(datos) {
            if (datos.files && datos.files[0]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    $("#img").attr("src", e.target.result);
                };
                reader.readAsDataURL(datos.files[0]);
            }
        },
        omitirFoto() {
            //this.dialogFoto = false;
            this.imgFoto = null;
            //this.$refs.webcam.stop();
            setTimeout(() => {this.$refs.webcam.start();}, 550);
            //await this.onstop();
            //await this.onStart();
        },
        
        async openModalPermissions(usuario){
            this.imagen = "/static/modal/usuarioUpdate.svg";
            this.dialogPermissions  = true;
            await this.getAllPermissionsUser(usuario);
        },
        async cerrarModalPermissions(){
            this.dialogPermissions      = false;
            this.loadingPermissions     = false;
            this.isSaving               = false;
            this.userPermissions        = null;
            this.itemsPermissionsUser   = []
            this.busqueda               = "";
        },
        async getAllPermissionsUser(usuario){
            this.userPermissions = usuario

            let parametros = {
                usuario_id : usuario.id,
                rol_id : usuario.rol_id
            }

            this.loadingPermissions = true
            await apiPermisos.getAllPermissionsUser(parametros).then(async response => {
                this.loadingPermissions = false
                this.itemsPermissionsUser = response.data;
            })
            .catch(err => {
                this.loadingPermissions = false
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los permisos.");
            })
        },

        async guardarPermissions(){
            let permisos = [];

            await this.itemsPermissionsUser.map(async val => {
                await val.permisos.map(val2 => {
                    if(val2.checked == true){
                        permisos.push(val2.name)
                    }
                })
            })

            let parametrosAdd = {
                usuario_id: this.userPermissions.id,
                rol_id : this.userPermissions.rol_id,
                permisos : permisos,
                accion: 'update',
                tipo:'todos'
            }

            if(permisos.length != 0){
                this.isSaving = true
                await apiPermisos.syncPermissionsUser(parametrosAdd).then( response => {
                    this.isSaving = false
                    Notify.Success("Operación exitosa", "El registro se guardó satisfactoriamente.");
                })
                .catch(err => {
                    this.isSaving = false
                    console.error(err);
                    Notify.ErrorToast("Ocurrió un error al actualizar los permisos del rol.");
                })
            }

            await this.cerrarModalPermissions()
        },

        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("usuarios.store")
            this.permisos.update = permisosStorage.includes("usuarios.update")
            this.permisos.delete = permisosStorage.includes("usuarios.delete")
        },
    },
    computed: {
        ...mapState("auth", ["datos", "menu"]),
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        },
        itemsPermissionsUserFiltered(){
            return this.itemsPermissionsUser.filter((p) => {
                return p.categoria.displayName.toLowerCase().indexOf(this.busqueda.toLowerCase()) != -1;
            });
        },
    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        let rol_valor = this.datosLogin.rol.id;
        this.rol_sesion = this.datosLogin.rol.id;
        this.urlImg = GetUrlImg.getURL();
        this.permisosVista();
        this.getRoles(null,'inicio')

        if (this.rol == "root") {
            this.getClientes();
        } else if (this.rol == "admin") {
            this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
        } else if (this.rol == "admin-empresa") {
            this.empresa_value_search = this.filters.empresa_id = this.datosLogin.empresa_id;
        } else if (this.rol == "admin-sucursal") {
            this.sucursal_value_search = this.filters.sucursal_id = this.datosLogin.sucursal_id;
        }else if (this.rol == "admin-depto" || this.rol == "empleado") {
            this.$router.push("/dashboard");
            Notify.Warning("¡Denegado!","Tu Rol no permite el acceso a esta vista.");
        }
    },
    mounted() {
        this.listar();
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    #swal2-content {
        color: rgb(150, 153, 154) !important;
        font-family: Montserrat;
        font-size: 28px;
        font-style: normal;
        font-weight: bold;
        line-height: 115.9%;
    }

    .checkbox-container {
        margin-top: 25px;
        margin-left: -80px;
        padding: 10px 15px;
    }

    .content {
        display: flex;
    }

    .content > * {
        position: absolute;
    }
    .color_rojo {
        color: red;
    }
    .layout {
        margin-top: 1px !important;
    }
    .botonModal {
        display: none !important;
    }

    .v-chip{
        font-family: Montserrat !important;
    }

    #btnModalReporte {
        display: none;
    }
    .menuClassAcciones{
        /* box-shadow: none; */
        border-radius: 10px!important;
        margin-top:15px;
    }
    .btnAcciones {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
    }
    .btnAcciones:hover {
        width: 135px !important;
        height: 42px !important;
        border-radius: 30px;
        text-transform: capitalize;
        background:#58C5D8 !important;
        color:#FFFFFF !important;
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        box-shadow: 0px 5px 8px rgba(26, 30, 66, 0.2);
        -webkit-transform: translatey(-1px);
        transform: translatey(-1px);
    }
    .btnAccionesContenedor {
        width: 300px;
        height: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        background-color: #FFF;
    }

    div.btnAccionesTitulo {
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesTitulo span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        color: #1E2245;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }
    .color_rojo {
        color: red;
    }
    .textoFoto {
        width: 284px;
        height: 30px;
        left: 218px;
        top: 518px;
        padding-left: 0px 65px;

        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 15px;
        /* or 150% */

        text-align: center;

        color: #96999A;
    }
    .btn-capturar{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.2px;
        display: inline-block !important;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        background: #1E2245 !important;
        box-shadow: 0px 8px 16px rgba(0, 126, 255, 0.16), inset 10px 11px 17px rgba(119, 124, 185, 0.11);
        border-radius: 80px;
        text-transform: none;
        margin-bottom: 5px !important;
    }
    .btn-omitir{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        display: inline-block !important;
        align-items: center;
        text-align: center;
        color: #96999A;
        background: transparent !important;
        border-radius: 80px;
        box-shadow: none !important;
        text-transform: none;
    }
      /* euicab fin modal tomar de fotos */
      .estiloFoto {
        font-family: "Montserrat";
        font-weight: 400 !important;
        color: #8a8fb4 !important;
        font-size: 13px !important;
        line-height: 16px;
        margin-top: -2% !important;
        padding-left: 25%;
        padding-right: 25%;
    }
    #no-background-hover::before {
        background-color: transparent !important;
        border-color: transparent!important;
    }
    /* euicab multiselectes para fotos he imagen */
    .btn-group {
        min-width: 80px;
        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .btn-group a:hover {
        text-decoration: none;
    }
    .dropdown-toggle {
        font-family: "Montserrat" !important;
        font-size: 16px !important;
        border: 0.5px solid rgba(0, 0, 0, 0.38);
        box-sizing: border-box;
        border-radius: 8px;
        padding: 9px 45px 8px 15px;
        width: 248px !important;
        height: 56px !important;
        outline: 0;
        color: rgba(0, 0, 0, 0.6);
        min-width: 80px;
        background-color: #FFFFFF;
        transition: background 0s ease-out;
        float: none;
        box-shadow: none;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        letter-spacing: normal;
        text-align: left;
        line-height: 36px;
    }
    .dropdown-toggle:hover {
        border: 0.5px solid rgba(0, 0, 0, 0.87);
        color: rgba(0, 0, 0, 0.87);
        background: #FFFFFF;
        cursor: pointer;
    }
    .dropdown-menu {
    /*
        position: absolute;
        top: -6px;
        left: 0;
        z-index: 1000;
        float: left;
        min-width: 260px;
        padding: 5px 0;
        margin: 2px 0 0;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #FFF;
        border: 1px solid #ECEEEF;
        border-radius: 4px;
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
        background-clip: padding-box;*/
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 1000;
        float: left;
        min-width: 260px;
        padding: 0;
        margin: 0;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #FFF;
    }
    .dropdown-menu > li > a {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        color: #96999A;
        padding: 10px 30px;
        display: block;
        clear: both;
        white-space: nowrap;
        text-decoration: none;
    }
    .dropdown-menu > li > a:hover {
        background: #96999A;
    }
    .dropdown-menu > li {
        overflow: hidden;
        width: 100%;
        position: relative;
        margin-bottom: -29px;
    }
    .caret {
        color: #96999A;
        font-size: 18px;
        position: absolute;
        top: 7px;
        margin-left: -24px;
        vertical-align: middle;
        right: 5px;
        line-height: 36px;
    }
    li {
        list-style: none;
    }
    /*fin multiselected foto e imagen */
    /*estilo modal tomarFoto */
    .v-btn-cerrar .v-btn:hover::before {
        background-color: transparent !important;
        pointer-events: none;
    }
    .v-btn-cerrar .v-btn:hover::after {
        background-color: transparent !important;
        pointer-events: none;
    }
    .v-btn-cerrar .v-btn:hover {
        background-color: transparent !important;
        pointer-events: none;
    }
    #btnModal_agregar{
        display: none;
    }
    .cursor-pointer{
        cursor:pointer;
    }
    .checadores_frase{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #828282;
    }

    .menuClassFoto{
        box-shadow: none;
    }
    
    .menuClassAccionesUsuario {
        border-radius: 10px !important;
    }
    
    .categoria{
        font-size: 18px;
        font-weight: 700;
    }

</style>
